import styles from "./Field.module.scss";

interface FieldProps {
    label: string;
    children: React.ReactNode;
    tooltip?: string;
}

export const Field = (props: FieldProps) => {
    return (
        <div className={styles.field}>
            <label className={styles.label}>{props.label}</label>
            {props.children}
        </div>
    );
};
